import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { Document } from './types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<Document, string>({
        query: (id) => `${APP_ENDPOINTS.DOCUMENT}/${id}`,
    });
